import React, { useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { appendBasePath } from '../../../utils/nav.utils';
import FullPageLoader from '../../Shared/FullPageLoader/FullPageLoader';
import StepsPageBackground from '../../Shared/StepsPageBackground/StepsPageBackground';
import RothConversionSteps from '../RothConversionSteps/RothConversionSteps';
import { scrollElementIntoFullView } from '../../../utils/dom-utils';
import './RothConversionLanding.scss';
import {
  ADDRESS_INCOMPLETE,
  APP_FAILURE,
  DOB_FAILURE,
  executingExchangeMessages,
  FOREIGN_ADDRESS,
  loadingExchangeAppMessages,
  NOT_RETAIL_CLIENT,
  ROTH_CONVERSION_NO_ELIGIBLE_BENES,
  ROTH_CONVERSION_NO_ELIGIBLE_FUNDS,
  //TIMEOUT,
} from '../../../settings/settings';
import { getRothConversionExecuteState } from '../../../redux/modules/executeRothConversion/executeRothConversion.selectors';
import { useHistory } from 'react-router';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import {
  getDateOfBirth,
  getIsAddressAvailable,
  getIsNotForeignAddress,
  getPersonalInformationData,
} from '../../../redux/modules/user/PersonalInformation/personalInformation.selectors';
import { getIsCorporateAccountType } from '../../../redux/modules/shoppingCart/shoppingCart.selectors';
import {
  isCustomerWebViewEnabled,
  isEmbeddedInIFrame,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import { isRothConversion } from '../../../utils/transactions-util';
import { getDoesRothConversionHaveEligibleFunds } from '../../../redux/modules/rothConversionTransaction/rothConversionTransaction.selectors';
import { getNumberOfRothBenes } from '../../../redux/modules/beneficiaries/beneficiaries.selectors';
import If from '../../Shared/If/If';
import { openModal } from 'src/redux/modules/modals/actions';
import iconHelp from 'src/assets/images/icon_help.svg';
import { BALANCES_AS_OF_MODAL } from 'src/redux/modules/modals/modals.module';
import { getBalanceAsOfDate } from 'src/redux/modules/funds/UserFunds/userFunds.selectors';
import { getApplicationStatus } from '../../../redux/modules/applicationData/applicationData.selectors';

const RothConversionLanding = ({ actions }) => {
  const applicationData = useSelector((state) => getApplicationStatus(state));
  const dispatch = useDispatch();
  //Possible errors
  const isNotForeignAddress = useSelector(getIsNotForeignAddress);
  const dateOfBirth = useSelector(getDateOfBirth);
  const balanceAsOfDate = useSelector(getBalanceAsOfDate);
  const isCorporateAccountType = useSelector(getIsCorporateAccountType);
  const isAddressAvailable = useSelector(getIsAddressAvailable);
  const isIFrame = useSelector(isEmbeddedInIFrame);
  const isCustomerWebView = useSelector(isCustomerWebViewEnabled);
  const isSalesforceRepRoth = useSelector(isSalesforceRep);
  const RothConversionHasFunds = useSelector(
    getDoesRothConversionHaveEligibleFunds
  );
  const moreThan1Roth = useSelector(getNumberOfRothBenes);
  const { retailEnabled } = useSelector(getPersonalInformationData);
  const isLoaderVisible = applicationData.isLoading;
  const message = applicationData.isLoading
    ? loadingExchangeAppMessages
    : '' //executeExchange.isLoading
    ? executingExchangeMessages
    : '';

  const executeRothConversionState = useSelector(getRothConversionExecuteState);
  const conversionExecuted = executeRothConversionState.isLoaded;
  const history = useHistory();

  const getError = () => {
    if (!dateOfBirth && !isCorporateAccountType) {
      return {
        type: DOB_FAILURE,
        hasError: true,
      };
    }
    if (!isNotForeignAddress) {
      return {
        type: FOREIGN_ADDRESS,
        hasError: true,
      };
    }
    if (!retailEnabled && !isSalesforceRepRoth) {
      return {
        type: NOT_RETAIL_CLIENT,
        hasError: true,
      };
    }
    if (!isAddressAvailable) {
      return {
        type: ADDRESS_INCOMPLETE,
        hasError: true,
      };
    }
    if (
      executeRothConversionState.hasFailed ||
      (!executeRothConversionState.confirmationNumber && conversionExecuted) ||
      executeRothConversionState.validationFailed ||
      applicationData.hasFailed
    ) {
      return {
        type: APP_FAILURE,
        hasError: true,
      };
    }
    if (!RothConversionHasFunds && isRothConversion()) {
      return {
        type: ROTH_CONVERSION_NO_ELIGIBLE_FUNDS,
        hasError: true,
      };
    }
    if (moreThan1Roth && isRothConversion()) {
      return {
        type: ROTH_CONVERSION_NO_ELIGIBLE_BENES,
        hasError: true,
      };
    }
    return {
      type: '',
      hasError: false,
    };
  };

  useEffect(() => {
    const { hasFailed } = executeRothConversionState;
    if (conversionExecuted) {
      if (
        !hasFailed &&
        executeRothConversionState.confirmationNumber &&
        !executeRothConversionState.validationFailed
      ) {
        history.push(appendBasePath('/roth-conversion/confirm'));
        scrollElementIntoFullView('roth-conversion-page-container');
      }
    }
  }, [executeRothConversionState, conversionExecuted, history]);

  scrollElementIntoFullView('roth-conversion-page-container');
  return (
    <div id="roth-conversion-page-container">
      <FullPageLoader
        isVisible={isLoaderVisible}
        hasError={getError().hasError}
        errorType={getError().type}
        messages={message}
      />
      <If test={!(isIFrame || (!isCustomerWebView && isSalesforceRepRoth))}>
        <StepsPageBackground />
      </If>
      <div className="container">
        <RothConversionSteps actions={actions} />
        <button
          className="qcd-landing-balance-tooltip roth-conversion-landing-balance-tooltip"
          onClick={() => dispatch(openModal(BALANCES_AS_OF_MODAL, {}))}
        >
          * Balances as of {balanceAsOfDate}
          <img
            alt="help"
            className="sell-landing-balance-tooltip-icon"
            id="balance-tooltip-icon"
            src={iconHelp}
          />
        </button>
        <hr />
        <p className="lrn-number">2820106</p>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    executeRothConversionTransaction: {
      confirmationNumber,
      tradeDate,
      success,
    },
  } = state;

  return {
    confirmationNumber,
    //hasPaperless: getHasMutualFundPaperlessConfirmations(state),
    tradeDate,
    success,
  };
};

export default compose(
  connect(mapStateToProps),
  withRouter
)(RothConversionLanding);
